<template>
  <div class="">
    <header class="tw-w-full tw-flex tw-justify-start tw-items-start tw-mb-8">
      <div
        class="dropdown tw-w-52 tw-relative tw-px-4 tw-py-2 tw-rounded-md tw-border"
      >
        <button
          class="tw-text-center tw-flex tw-items-center tw-gap-4 tw-text-xl"
          @click="toggle"
        >
          <svg
            class="tw-h-6 tw-w-6 tw-fill-current tw-text-gray-500"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
            <path
              d="M152 64H296V24C296 10.75 306.7 0 320 0C333.3 0 344 10.75 344 24V64H384C419.3 64 448 92.65 448 128V448C448 483.3 419.3 512 384 512H64C28.65 512 0 483.3 0 448V128C0 92.65 28.65 64 64 64H104V24C104 10.75 114.7 0 128 0C141.3 0 152 10.75 152 24V64zM48 448C48 456.8 55.16 464 64 464H384C392.8 464 400 456.8 400 448V192H48V448z"
            />
          </svg>
          <span>{{ options[selectedOptionIndex] }}</span>
        </button>
        <div
          class="tw-absolute tw-w-52 tw-top-0 tw-mt-[40px] tw-left-0 tw-bg-gray-50 tw-border tw-rounded-lg tw-shadow-md tw-drop-shadow-md"
          v-if="active"
        >
          <button
            class="tw-px-4 tw-py-1 hover:tw-bg-gray-100 tw-w-full tw-text-left"
            v-for="(option, index) in options"
            :key="option"
            @click="
              {
                active = false;
                selectedOptionIndex = index;
              }
            "
          >
            {{ option }}
          </button>
        </div>
      </div>
    </header>
    <section class="current-data tw-grid tw-grid-cols-5 tw-gap-4">
      <div
        v-for="content in contents"
        :key="content.title"
        class="tw-bg-white tw-border tw-rounded-sm tw-p-4"
      >
        <div class="card-title tw-text-xl">{{ content.title }}</div>
        <div
          class="card-value tw-text-right tw-text-primary tw-font-bold tw-text-[4rem]"
        >
          {{ content.value | numFormat }}
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export default {
  name: "StatisticalData",
  data() {
    return {
      contents: {
        createdRoom: {
          title: "Created room",
          value: "-",
        },
        responseRoom: {
          title: "Response room",
          value: "-",
        },
        noResponseRoom: {
          title: "No response room",
          value: "-",
        },
      },
      options: ["Last 30 days", "Last 7 days"],
      selectedOptionIndex: 0,
      active: false,
    };
  },
  watch: {
    selectedOptionIndex: {
      immediate: true,
      handler: async function (index) {
        let filter = {
          end: dayjs().utc().format(),
          start: "0001-01-01T00:00:00Z",
        };
        switch (index) {
          case 0:
            filter.start = dayjs().subtract(30, "days").utc().format();
            break;
          case 1:
            filter.start = dayjs().subtract(7, "days").utc().format();
            break;
          default:
            break;
        }

        await this.updateContent(filter);
      },
    },
  },
  methods: {
    toggle() {
      this.active = !this.active;
    },
    async updateContent(range) {
      const createdRoom = await this.$store.dispatch("chat/createdRoom", {
        start: range.start,
        end: range.end,
      });
      const responsedRoom = await this.$store.dispatch("chat/responsedRoom", {
        start: range.start,
        end: range.end,
      });
      const noResponsedRoom = await this.$store.dispatch(
        "chat/noResponsedRoom",
        {
          start: range.start,
          end: range.end,
        }
      );

      // console.log("createdRoom", createdRoom, responsedRoom, noResponsedRoom);
      this.contents.createdRoom.value = createdRoom;
      this.contents.responseRoom.value = responsedRoom;
      this.contents.noResponseRoom.value = noResponsedRoom;
    },
  },
  filters: {
    numFormat(value) {
      return value?.toLocaleString();
    },
  },
};
</script>

<style>

</style>
